module.exports = "../fonts/vendor/primevue/resources/themes/lara-light-indigo/Inter-Light.woff2?2d5198822ab091ce430554a436cdf53c";